export let props = ['column']
export let model = {
}
export let computed = {
}
